import { useCallback, useEffect, useState, } from 'react';
import { annualSales, getSales, monthlySales, quarterlySales } from '../Features/SalesDep/Sales/SalesSlice';
import { usdFormat } from '../Utility/usdFormat';
import SalesGraphYTD from '../Components/Graphs/SalesGraphYTD';
import Loading from '../Components/Loading';
import { useAppDispatch, useAppSelector } from '../hooks';
import { Button, Col, Container, Row } from 'reactstrap';
import MonthlySalesReportCard from '../Features/SalesDep/Sales/MonthlySalesReportCard';
import QuarterlySalesReportCard from '../Features/SalesDep/Sales/QuarterlySalesReportCard';
import SalesGraphQuarter from '../Components/Graphs/SalesGraphQuarter';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

type MonthItem = {
    monthSalesCY: number;
    monthSalesLY: number;
    month: string;
    monthGrossProfitCY: number;
    monthGrossProfitLY: number;
};

type QuarterItem = {
    quarter: string;
    quarterSalesCY: number;
    quarterQuotaCY: number;
    quarterQuotaPercent: number;
    quarterGrossProfitCY: number;
};

type AnnualItem = {
    salesThisYear: number;
    salesLastYear: number;
};

const SalesReport = () => {
    const [ activeTab, setActiveTab ] = useState<string>('Tab1');
    const monthlyData: MonthItem[] = useAppSelector(monthlySales);
    const quarterlyData: QuarterItem[] = useAppSelector(quarterlySales);
    const annualData: AnnualItem[] = useAppSelector(annualSales);
    const loading = useAppSelector((state) => state.sales.loading)
    const error = useAppSelector((state) => state.sales.error)
    const dispatch = useAppDispatch();

//     const onRefresh = useCallback(() => {
//         dispatch(getSales());
//     }, []);
    
    const labels = monthlyData.map((_, index) => 
        String(index + 1)
    );
    
    const monthlySalesCY = monthlyData.map((item) => 
        Number(item.monthSalesCY)
    );

    const monthlySalesLY = monthlyData.map((item) =>
        Number(item.monthSalesLY)
    );

    const quarterLabels = quarterlyData.map((_, index) => 
        String(index + 1)
    );

    const quarterlySalesCY = quarterlyData.map((item) => 
        Number(item.quarterGrossProfitCY),
    );

    const qaurterlyQuotaLY = quarterlyData.map((item) =>
        Number(item.quarterQuotaCY)
    );

    const handleTabTwo = async () => {
        setActiveTab('Tab2')
        logEvent(analytics, 'quarter_sales_web', {
            name: 'quarterly sales view',
            description: 'User switched to quarterly sales view'
        });
    };

    const tabContent = () => {
        switch (activeTab) {
            case 'Tab1':
                return (
                   <Container>
                        {monthlySalesCY.length === 0
                        ? (<Loading />
                        ):(
                            <>
                                <Row style={{ paddingTop: 15 }}>
                                    <SalesGraphYTD 
                                        data={monthlySalesCY} 
                                        data2={monthlySalesLY}
                                        labels={labels}    
                                    />
                                </Row>
                                <Row style={{ paddingTop: 15 }}>
                                    <MonthlySalesReportCard 
                                        data={monthlyData} 
                                        // salesCY={annualData.salesThisYear} 
                                        // salesLY={annualData.salesLastYear}
                                    />
                                </Row>
                            </>
                        )}
                    </Container>
                )
            case 'Tab2':
                return (
                    <Container>
                        {quarterlySalesCY.length === 0
                        ? (<Loading />
                        ):(
                            <>
                                <Row style={{ paddingTop: 15 }}>
                                    <SalesGraphQuarter 
                                        data={quarterlySalesCY} 
                                        data2={qaurterlyQuotaLY}
                                        labels={quarterLabels}
                                    />
                                </Row>
                                <Row style={{ paddingTop: 15 }}>
                                    <QuarterlySalesReportCard 
                                        data={quarterlyData}
                                        // salesCY={annualData.salesThisYear}
                                        // salesLY={annualData.salesLastYear}
                                    />
                                </Row>
                            </>
                        )}
                    </Container>
                )
            default:
                break;
        }
    }

    return (
        <>
        {loading 
        ? (<Loading />) 
        : error 
        ? ( <Row>
                <span>{error}</span>
            </Row>)
        : ( 
                <Container className='bg-light'>
                    <Row 
                        style={{ 
                            display: 'flex', 
                            marginTop: 10,
                        }}
                    >
                        <div style={{ flex: 1 }}>
                            <Button
                                className={activeTab === 'Tab1' ? `tabButton bg-primary` : `tabButton bg-white`}
                                onClick={() => setActiveTab('Tab1')}
                            >
                                <span style={{ fontWeight: 'bold' }}>Monthly</span>
                            </Button>
                        </div>
                        <div style={{ flex: 1 }}>
                            <Button
                                className={activeTab === 'Tab2' ? `tabButton bg-primary` : `tabButton bg-white`}
                                onClick={handleTabTwo}
                            >
                                <span style={{ fontWeight: 'bold' }}>Quarterly</span>
                            </Button>
                        </div>
                    </Row>
                    <Row className='pb-5'>
                        {tabContent()}
                    </Row>
                </Container>
            )}
        </>
    )
};

export default SalesReport;